import type { UseQueryResult } from '@tanstack/react-query'
import { Skeleton } from 'ui'
import { SkeletonComposition } from './SkeletonComposition'

export function WaitForQuery<T extends UseQueryResult>({
  query,
  children,
  loading,
}: {
  query: T
  children: React.FC<Extract<T, { isSuccess: true }>['data']>
  loading?: React.ReactNode
}) {
  if (query.isLoading || query.error || !query.data) {
    if (loading) {
      return loading
    }

    return <SkeletonComposition />
  }

  return children(query.data)
}
